module.exports = __webpack_public_path__ + "static/media/janelia_logo.2e1f9dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/janelia_logo.png
// module id = 154
// module chunks = 0